export const SyncableSettings = [
  'graph_type', 
  'C19', 
  'running_format_velocity',
  'optimal_range',
  'customPPM',
  'custom_range_bottom',
  'custom_range_top',
];